export const LOCAL_STORAGE_KEYS = {
  USER_SUBSCRIBED: `user_subscribed`,
  USER_TOKEN: 'token',
  REFRESH_TOKEN: 'refresh_token',
  SHIPPING_FORM: 'shippingForm', // TODO: renombrar a shipping_form
} as const;

export type LocalStorageKeyOptions = (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS];

export const SESSION_STORAGE_KEYS = {
  LAST_PURCHASE_BOND: 'last_purchase_bond',
  PAYPAL_CUSTOMER_DATA: 'paypal_customer_data',
  PAYPAL_PAYMENT_DATA: 'paypal_payment_data',
  GEO_DETECTION: 'geo_detection',
} as const;

export type SessionStorageKeyOptions = (typeof SESSION_STORAGE_KEYS)[keyof typeof SESSION_STORAGE_KEYS];
